import Enum from './enum'

/**
 * 先生アカウントの再発行
 */
class RegenerateTeacherAccount extends Enum {
    static YES = 1; // 再発行する
    static NO = 0; // しない

    static values() {
        return {
            [this.YES]: '再発行する',
            [this.NO]: 'しない',
        }
    }
}

export default RegenerateTeacherAccount;
